import React, { Component } from 'react';

import { Row } from 'reactstrap';

import Button from '../../components/button';
import Column from '../../components/column';
import Icon from '../../components/icon';
import PageHeader from '../../components/pageHeader';
import Text from '../../components/text';

import './styles.scss';

const SUPPORT_URL = 'https://support.accurx.com/';

class ServiceClosedPage extends Component {
  render = () => {
    return (
      <div className="service-closed">
        <Row>
          <Column xs={12} md={{ size: 6, offset: 3 }}>
            <div className="service-closed__content">
              <Icon icon="induction" large />

              <PageHeader
                title="Switch has closed"
                centered
                white
                light
                large
              />

              <Text centered white large spacing={{ large: true }}>
                Switch is no longer available. If you need help, or have
                questions about your account, please contact our support team.
              </Text>

              <div className="service-closed__buttons">
                <Button
                  text="Contact support"
                  href={SUPPORT_URL}
                  blue
                  large
                  fullWidth
                />
              </div>
            </div>
          </Column>
        </Row>
      </div>
    );
  };
}

export default ServiceClosedPage;
